<div class="row" *ngIf="detail!=null">
    <div class="col">
        <label for="warehouse" class="form-label">Bodega</label>
        <div class="input-group bg-white rounded">
            <app-input-autocomplete
                [allBorderRadius]="true"
                [inputs]="inputs.warehouse"
                [placeholder]="'Ingresa una bodega'"
                [filterElements]="filterWarehouses"
                (inputMethod)="writeWarehouse($event.event)"
                (changeStatus)="checkWarehouse($event.filterElement)"
                (getTitle)="
                    $event.filterElement.title =
                        $event.filterElement.code +
                        ' - ' +
                        $event.filterElement.name
                "
            ></app-input-autocomplete>
        </div>
    </div>
    <div class="col form-group" *ngIf="!isOut">
        <label for="quantity" class="form-label">Cantidad</label>
        <div class="input-group">
            <input
                type="number"
                name="quantity"
                id="quantity"
                [disabled]="warehouseId==null || warehouseId==detail.warehouseId"
                [(ngModel)]="detail.quantity"
                class="form-control"
            />
        </div>
    </div>
    <div class="col form-group" *ngIf="!isOut">
        <div class="d-flex flex-col">
            <label class="form-label">Existencias</label>
            <label class="form-label text-primary p-2">{{detail.existences}}</label>
        </div>
    </div>
</div>